import React from 'react';

import { useApp } from '../../store/AppContext';
import SidebarFooter from '../SidebarFooter';
import SidebarHeader from '../SidebarHeader';
import SidebarNav from '../SidebarNav';

export default function Sidebar() {
  const { navBoxHeight, sidebarCollapsed } = useApp();
  return (
    <nav
      className="sidebar [transition:width_0.2s_ease]"
      style={{
        width: sidebarCollapsed ? 60 : 210,
        minWidth: sidebarCollapsed ? 60 : 210,
        maxWidth: sidebarCollapsed ? 60 : 210,
      }}
    >
      <SidebarHeader />
      <div
        className="overflow-y-auto overflow-x-hidden min-h-[0]"
        style={{ height: navBoxHeight != null ? `${navBoxHeight}px` : undefined }}
      >
        <SidebarNav />
      </div>
      <SidebarFooter />
    </nav>
  );
}
